Vue.use(Router);

import Vue from 'vue'
import Router from 'vue-router'
import MainLayout from '../Layouts/mainLayout'

import Features from '../Pages/Features/features'
// import Demo from '../Pages/Demo/demo'
import Manual from '../Pages/Manual/manual'

export default new Router({
    routes: [
        {
            path: '/',
            component: MainLayout,
            children: [
                // {
                //     path: 'Demo',
                //     component: Demo,
                //     meta: {subNavRoute: 'Demo'}
                // },
                {
                    path: 'Manual',
                    component: Manual,
                    meta: {subNavRoute: 'Manual'},
                    children: [

                        {
                            path: ':section',
                            component: Manual,
                            meta: {subNavRoute: 'Manual'}
                        },
                        {
                            path: '',
                            component: Manual,
                            meta: {subNavRoute: 'Manual'}
                        }
                    ]
                },
                {
                    path: '*',
                    component: Features,
                    meta: {subNavRoute: 'Features'}
                }
            ]
        }
    ],
    mode: 'history'
})
